<template>
  <div class="wrapp_content"
       style="width: 100%; height: 500px;">
    <!--添加设备 -->
    <div class="">
      <el-card class="box-card">
        <div slot="header"
             class="clearfix">
          <span>设备列表</span>
          <el-button style="float: right; padding: 3px 0"
                     type="text">操作按钮</el-button>
        </div>
        <div v-for="o in eqlist"
             :key="o.ID"
             class="text item"
             @click="selectPos(o)">
          {{ o.DeviceName }}
          <span class="label_flag"
                v-if="!o.DevicePosition">未关联</span>
          <el-button style="float: right; padding: 3px 0"
                     type="text">编辑</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'editeqlist',
  data() {
    return {
      eqlist: []
    }
  },
  mounted() {
    ApiService.tree.devicelist({
      mileageID: window.R_config.modelId
    }).then((res) => {
      console.log(res.data)
      if (res.code == 0) {
        this.eqlist = res.data
      }
    })
  },
  methods: {
    selectPos(obj) {
      window.SetClickMode(3)
      if (!obj.DevicePosition) {
        window.PData = {
          type: 'selectPos',
          data: obj
        }
      } else {
        window.RemoveLabel2d(obj.ID)
        window.AddLabel2d(110, obj.DevicePosition,

          1, 100, '#fff', "<div class='round'>dfsdfsdfsdfsdf</div>", obj.ID, 85, obj.ChildID)
        window.SetCamera(obj.CameraPos)
      }

      //  console.log( GetCamera());
    },
    SaveDevice() {
      let isChecked = true
      this.$refs['ruleForm'].validate((valid) => {
        isChecked = valid
      })
      if (!isChecked) {
        return
      }
      ApiService.tree.add({
        id: 0,
        DeviceName: this.ruleForm.DeviceName,
        DeviceItem: '',
        TagWidth: this.ruleForm.TagWidth,
        TagHeight: this.ruleForm.TagHeight,
        TagStyle: this.ruleForm.TagStyle,
        DevicePosition: '',
        CameraPos: '',
        mileageID: window.R_config.modelId,
        ChildID: '10'
      }).then((res) => {
        console.log(res.data)
        this.$refs['ruleForm'].resetFields()
      })
    }
  }
}
</script>

<style scoped>
.ruleFormcss {
  margin-top: 0.5rem;
}
.label_flag {
  margin-left: 0.2rem;
  color: #de6989;
  font-size: 0.12rem;
}
.box-card {
  width: 2.8rem;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
  text-align: left;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
  text-align: left;
}

.clearfix:after {
  clear: both;
}

.clearfix {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/equipment/editeqlist.vue